import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl} from '../Univ.js'
function VendorSearch(props) {
    const [inputValue, setInputValue] = useState('');
    const [distributor, setDistributor] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [searchClicked, setSearchClicked] = useState(false);
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }
    useEffect(() => {
        if (searchClicked) {
            fetchData();
        }
    }, [searchClicked]);
    function fetchData() {
        setIsLoading(true);
        axios.get(baseUrl + `dist-search/?search=${searchTerm}`)
            .then(response => {
                setDistributor(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    function handleSearchButtonClick() {
        setSearchClicked(true);
    }
    function handleSearchInputChange(event) {
        setSearchTerm(event.target.value);
    }
    const columns = [
        {
            field: 'id', headerName: 'Id',
            renderCell: (params) => (
                <Link to={`/vendor-payment/${params.row.id}/`}>
                    {params.value}
                </Link>
            ),
            width: 30,
        },
        {
            field: 'name', headerName: 'Distributor',
            renderCell: (params) => (
                <Link to={`/vendor-payment/${params.row.id}/`}>
                    {params.value}
                </Link>
            ),
            width: 250,
        },
        {field: 'person', headerName: 'Contact', width: 140,},
        {field: 'gst', headerName: 'GST', width: 160,},
        {field: 'email', headerName: 'Email', width: 230,},
        {field: 'mobile', headerName: 'Mobile', width: 100,},
        {field: 'address', headerName: 'Address', width: 300,},
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Search Distributor</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <input className="form-control" type="headerName" placeholder="id, address, name, mobile"
                                   value={searchTerm} onChange={handleSearchInputChange}/>
                            <button className="btn btn-primary" onClick={() => fetchData()}>Search</button>
                        </div>
                    </div>
                </div>

                {!isLoading && distributor.length > 0 ? (
                    <div style={{height: '100%', width: '100%'}} className="mt-5">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={distributor}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar}}
                            autoHeight
                        />
                    </div>
                ) : (
                    <></>
                )}

            </div>
        </section>
    )
}
export default VendorSearch;
